import React from 'react'
import { createRoot } from 'react-dom/client'
import { ApolloProvider, useQuery } from '@apollo/client'
import client from '../client'
import fetchQuestions from '../queries/adminQuestions'
import QuestionFormModal from '../components/question-form-modal'
import { formatDate } from '../utils'
import { uniq } from 'ramda'

const questionClassName = (question) => {
  if (question.archived) {
    return 'disabled'
  } else {
    return ''
  }
}

function QuestionList(props) {
  const [filterCategory, setFilterCategory] = React.useState(null)
  const [showArchived, setShowArchived] = React.useState(false)
  const [showModal, setShowModal] = React.useState(false)
  const [editingQuestion, setEditingQuestion] = React.useState({})
  // const [categories, setCategories] = React.useState(props.categories)
  const [learnerTypes, setLearnerTypes] = React.useState(props.learnerTypes)
  const [stages, setStages] = React.useState(props.stages)

  const { loading, error, data } = useQuery(fetchQuestions)

  React.useEffect(() => {
    // equalize table div heights
    const tableDivs = Array.from(
      document.querySelectorAll('table.fancy td > div')
    )

    if (tableDivs.length > 0) {
      const heights = tableDivs.map((d) => d.offsetHeight)
      const maxHeight = Math.max(...heights)

      tableDivs.map((d) => {
        d.style.height = `${maxHeight}px`
      })
    }
  })

  const toggleShowArchived = () => {
    setShowArchived(!showArchived)
  }

  const toggleShowArchivedText = () => {
    if (showArchived) {
      return 'Hide archived questions'
    } else {
      return 'Show archived questions'
    }
  }

  const onCategoryFilterChange = (event) => {
    setFilterCategory(event.target.value)
  }

  const openQuestionForm = (questionId) => {
    const categories = uniq(data.adminQuestions.map((q) => q.category))
    const question = data.adminQuestions.find((q) => q.id === questionId)
    const formProps = {
      question,
      learnerTypes,
      stages,
      categories,
      onSubmit: closeQuestionForm,
    }

    setEditingQuestion(formProps)
    setShowModal(true)
  }

  const closeQuestionForm = () => {
    setShowModal(false)
  }

  const showCheckMark = (preview) => {
    if (preview) {
      return (
        <i style={{ color: '#1DAEA6' }} className="material-icons">
          done
        </i>
      )
    }
  }

  let categories =
    data?.adminQuestions &&
    uniq(data.adminQuestions.map((q) => q.category.name))

  let filteredQuestions = data?.adminQuestions
  if (data?.adminQuestions && filterCategory) {
    filteredQuestions = data?.adminQuestions.filter(
      (q) => q.category.name === filterCategory
    )
  }

  if (filteredQuestions && showArchived === false) {
    filteredQuestions = filteredQuestions.filter((q) => q.archived === false)
  }

  return (
    <div className="admin-questions">
      <div className="header">
        <h1>Questions</h1>
        <nav className="actions">
          <a className="button" href="/admin/questions/new">
            New Question
          </a>
          <a className="button" href="/admin/questions.csv">
            Export
          </a>
        </nav>
      </div>
      <table className="fancy">
        <thead>
          <tr>
            <th>
              <div>Text</div>
            </th>
            <th>
              <div>
                <select onChange={onCategoryFilterChange} className="choices">
                  <option value="" disabled selected="selected">
                    Filter by Category
                  </option>
                  {categories &&
                    categories.map((category) => (
                      <option key={category} value={category}>
                        {category}
                      </option>
                    ))}
                </select>
              </div>
            </th>
            <th>
              <div>Stage</div>
            </th>
            <th>
              <div>Learner Type</div>
            </th>
            <th>
              <div># of Assignments</div>
            </th>
            <th>
              <div>Preview</div>
            </th>
            <th>
              <div>Last Modified</div>
            </th>
          </tr>
        </thead>
        <tbody>
          {filteredQuestions &&
            filteredQuestions.map((q) => (
              <tr
                key={q.id}
                className={questionClassName(q)}
                onClick={() => openQuestionForm(q.id)}
              >
                <td>
                  <div>
                    <span style={{ maxWidth: '100%' }}>{q.text}</span>
                  </div>
                </td>
                <td>
                  <div>{q.category.name}</div>
                </td>
                <td>
                  <div>{q.stage}</div>
                </td>
                <td>
                  <div>{q.learnerType}</div>
                </td>
                <td>
                  <div style={{ alignItems: 'center' }}>
                    {q.assignmentCount}
                  </div>
                </td>
                <td>
                  <div>{showCheckMark(q.preview)}</div>
                </td>
                <td>
                  <div>{formatDate(q.updatedAt)}</div>
                </td>
              </tr>
            ))}
        </tbody>
      </table>
      <header className="header">
        <nav className="actions">
          <a onClick={toggleShowArchived}>{toggleShowArchivedText()}</a>
        </nav>
      </header>
      <QuestionFormModal
        isOpen={showModal}
        onCancel={closeQuestionForm}
        formProps={editingQuestion}
      />
    </div>
  )
}

const questionList = document.getElementById('question-list')
if (questionList) {
  const csrfTag = document.querySelector('meta[name=csrf-token]')
  const csrfToken = csrfTag.getAttribute('content')
  const categories = JSON.parse(questionList.getAttribute('data-categories'))
  const learnerTypes = JSON.parse(
    questionList.getAttribute('data-learner-types')
  )
  const stages = JSON.parse(questionList.getAttribute('data-stages'))
  const props = { csrfToken, categories, learnerTypes, stages }

  const root = createRoot(questionList)
  root.render(
    <ApolloProvider client={client}>
      <QuestionList {...props} />
    </ApolloProvider>
  )
}
